// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e19727ce","95":"e7edecc1","193":"fd8868db","222":"0ef902c5","414":"99dd7116","634":"6d9d4076","652":"917e7fd2","668":"d3be2db2","931":"2384b106","960":"6303f37c"}[chunkId] + ".chunk.js";
};